import { getAllNotificaciones } from "api";
import useQuery from "hooks/useQuery";
import { useEffect, useState } from "react";
import { showErrorModal } from "utils";

const useNotificaciones = () => {
  const [totales, setTotales] = useState();

  const { loading, refetch } = useQuery({
    autoFetch: false,
    queryFn: getAllNotificaciones,
    onSuccess: (res) => {
      setTotales(res?.data?.totales);
    },
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = () => {
    // const query = queryString.stringify({
    //   notificacionTipo: ['solicitud', 'vinculacion'].join(",")
    // });
    refetch();
  }

  useEffect(() => {
    fetch();
  }, []);

  return {
    totales,
    setTotales,
    loading,
    fetch,
  }
}

export default useNotificaciones;